import { Vector4 } from "three";
import getMaterialWithUniforms from "../../instancing/materials/getMaterialWithUniforms";
import RectangleMesh from "../../instancing/Meshes/RectangleMesh";
import RectOutlineMesh from "../../instancing/Meshes/RectOutlineMesh";

export function getDuplicationMesh() {
  const conf = { posX: 1, posY: 1 };
  const colorMap = Array(1).fill(new Vector4(1, 0.2, 0.7, 0.7));
  const matConf = {};
  const materialConf = getMaterialWithUniforms(matConf)
    .setColorMap(colorMap)
    .setPaddingX([-1, 1, -1, 1])
    .setPaddingY([-4, -4, 4, 4])
    .setOffset([0, 0]);

  return new RectangleMesh(materialConf, conf);
}

export function getDeletionMesh() {
  const conf = { posX: 1, posY: 1 };
  const colorMap = Array(1).fill(new Vector4(1, 0.2, 0.7, 1));
  const matConf = {};
  const materialConf = getMaterialWithUniforms(matConf)
    .setColorMap(colorMap)
    .setBorderWidth(1)
    .setRaycastBorderWidth(5)
    .setPaddingX([-1, 1, -1, 1])
    .setPaddingY([-4, -4, 4, 4])
    .setOffset([0, 0]);

  return new RectOutlineMesh(materialConf, conf);
}

export function drawCalls(reads, mesh) {
  const count = reads.length;
  const isAppend = true;
  const setX = mesh.updateX({ count, isAppend });
  const setY = mesh.updateY({ count, isAppend });

  for (let i = 0; i < count; i++) {
    const { region, level } = reads[i];
    const x0 = region.g0;
    const x1 = region.g1;
    const y = level + 0.5;

    setX(i, x0, x1, x0, x1);
    setY(i, y, y, y, y);
  }
}
